<div class="modal normal modal-example-discard-changes active">
  <span class="icon icon-cancel" data-no-close-modal="true" id="spnDiscard" (click)="closeDiscard()"></span>
  <div class="modal-wrapper">
    <div class="discard-changes">
      <p [class.hidden]="!isMainDiscard" class="text-03-m-regular text-04-d-regular white">Si descartas los cambios volverás a ver los resultados que ya tenías anteriormente.</p>
      <p [class.hidden]="isMainDiscard" class="text-03-m-regular text-04-d-regular white">Si te vas sin actualizar resultados, no podrás ver los nuevos precios.</p>
      <button class="btn solid-secondary" id="closeButtonOnPopup" (click)="discardSwInput()">Descartar cambios</button>
      <button class="btn negative-line white" id="submitButtonOnPopup" [class.hidden]="!hasError" (click)="closeDiscard()">Seguir editando</button>
    </div>
  </div>
</div>
